import { Box, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';

export const VideoContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  borderRadius: 8,
  backgroundColor: COLORS.Black,
  aspectRatio: '4 / 3',
});

export const VideoElement = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const ViewfinderOverlay = styled(Box)({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ViewfinderFrame = styled(Box)({
  position: 'relative',
  width: '70%',
  aspectRatio: '3 / 1',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    width: 24,
    height: 24,
    borderColor: COLORS.NavyBlue,
    borderStyle: 'solid',
  },
  '&::before': {
    top: 0,
    left: 0,
    borderWidth: '3px 0 0 3px',
  },
  '&::after': {
    top: 0,
    right: 0,
    borderWidth: '3px 3px 0 0',
  },
});

export const ViewfinderBottomLeft = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: 24,
  height: 24,
  borderColor: COLORS.NavyBlue,
  borderStyle: 'solid',
  borderWidth: '0 0 3px 3px',
});

export const ViewfinderBottomRight = styled(Box)({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: 24,
  height: 24,
  borderColor: COLORS.NavyBlue,
  borderStyle: 'solid',
  borderWidth: '0 3px 3px 0',
});

export const ScanLine = styled(Box)({
  position: 'absolute',
  left: 0,
  right: 0,
  top: '50%',
  height: 2,
  backgroundColor: COLORS.NavyBlue,
  opacity: 0.7,
});

export const HintText = styled(Box)({
  position: 'absolute',
  bottom: 12,
  left: 0,
  right: 0,
  textAlign: 'center',
  fontSize: 12,
  color: COLORS.White,
  textShadow: '0 1px 3px rgba(0,0,0,0.8)',
  padding: '0 16px',
});

export const ErrorContainer = styled(Box)({
  padding: 24,
  textAlign: 'center',
  color: COLORS.DarkRed,
  fontSize: 14,
  backgroundColor: COLORS.LightRedBackground,
  borderRadius: 8,
});
